/* IC Glass v2 (TASK-22): header, clock, drawer, tabs, series hover, footer line field. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: transparent over the home hero, solid once the hero has scrolled past. */
  var hdr = document.querySelector('.icg-hdr--overlay');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var heroEl = document.querySelector('.icg-hero, .icg-bnr');
    if (heroEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        hdr.classList.toggle('is-solid', entries[0].intersectionRatio < 0.4);
      }, { threshold: [0, 0.4, 1] }).observe(heroEl);
    }
  }

  /* Sale bar: hide it once its end time has passed (the page can be cached past it); while it is on screen the fixed
     home header and the drawer sit under it (--icg-sale-off), and it scrolls away above the sticky header. */
  var sale = document.querySelector('[data-icg-sale]');
  if (sale) {
    var saleEnd = +sale.getAttribute('data-end') * 1000;
    if (saleEnd && Date.now() >= saleEnd) {
      sale.remove();
    } else {
      var saleH = sale.offsetHeight, rootStyle = document.documentElement.style;
      var saleOff = function () { rootStyle.setProperty('--icg-sale-off', Math.max(0, saleH - window.scrollY) + 'px'); };
      window.addEventListener('scroll', saleOff, { passive: true });
      saleOff();
    }
  }

  /* Riverside clock: IC Glass ships from Riverside, California (Pacific time). */
  var clock = document.querySelector('[data-icg-clock]');
  if (clock) {
    var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: '2-digit', minute: '2-digit', hour12: false });
    var hourFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hour12: false });
    var tick = function () {
      var now = new Date();
      var h = parseInt(hourFmt.format(now), 10) % 24;
      var part = h >= 6 && h < 17 ? 'DAY' : h >= 17 && h < 20 ? 'EVENING' : 'NIGHT';
      clock.textContent = 'RIVERSIDE ' + fmt.format(now) + ' ' + part;
    };
    tick();
    setInterval(tick, 20000);
  }

  /* Mobile drawer. */
  var burger = document.querySelector('[data-icg-burger]');
  var drawer = document.querySelector('[data-icg-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (hdr) hdr.classList.toggle('is-solid', open || window.scrollY > window.innerHeight * 0.6);
    });
  }

  /* Long header menu (the live site's 14 links): when they do not fit one row, hide the clock, then close the gaps, then fold the links into the drawer. */
  var lhdr = document.querySelector('.icg-hdr--links'), lnav = lhdr && lhdr.querySelector('.icg-hdr__nav');
  if (lnav) {
    var fit = function () {
      lhdr.classList.remove('is-tight', 'is-snug', 'is-folded');
      if (window.innerWidth < 990) return;
      ['is-tight', 'is-snug', 'is-folded'].forEach(function (c) { if (lnav.scrollWidth > lnav.clientWidth + 1) lhdr.classList.add(c); });
    };
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* Tabs. */
  document.querySelectorAll('[data-icg-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  /* Series: hovering a row swaps the big sticky image. */
  document.querySelectorAll('[data-icg-series]').forEach(function (root) {
    var stage = root.querySelector('[data-icg-stage]');
    if (!stage) return;
    root.querySelectorAll('[data-icg-img]').forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        root.querySelectorAll('.icg-row.is-active').forEach(function (r) { r.classList.remove('is-active'); });
        row.classList.add('is-active');
        if (stage.getAttribute('src') === row.dataset.icgImg) return;
        stage.style.opacity = 0;
        setTimeout(function () { stage.src = row.dataset.icgImg; stage.srcset = ''; stage.alt = row.dataset.icgAlt || ''; stage.style.opacity = 1; }, 180);
      });
    });
  });

  /* Footer line field: a grid of short strokes that all point at one moving focus (the cursor
     when it is over the footer, otherwise a slow drift). Halcyon's footer does the same. */
  document.querySelectorAll('[data-icg-lines]').forEach(function (canvas) {
    if (!canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var w = 0, h = 0, dpr = 1, focus = { x: 0, y: 0 }, target = null, visible = false, t0 = performance.now();
    var size = function () {
      var r = canvas.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    var draw = function (now) {
      var step = w < 750 ? 34 : 46, len = step * 0.72;
      if (target) { focus.x += (target.x - focus.x) * 0.12; focus.y += (target.y - focus.y) * 0.12; }
      else { var s = (now - t0) / 9000; focus.x = w * (0.5 + 0.42 * Math.sin(s)); focus.y = h * (0.1 + 0.08 * Math.cos(s * 1.3)); }
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = getComputedStyle(canvas).color || 'rgba(0,0,0,.28)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (var y = step / 2; y < h; y += step) {
        for (var x = step / 2; x < w; x += step) {
          var a = Math.atan2(focus.y - y, focus.x - x);
          var d = Math.min(1, Math.hypot(focus.x - x, focus.y - y) / (w * 0.6));
          var l = len * (0.45 + 0.55 * d);
          var dx = Math.cos(a) * l / 2, dy = Math.sin(a) * l / 2;
          ctx.moveTo(x - dx, y - dy); ctx.lineTo(x + dx, y + dy);
        }
      }
      ctx.stroke();
      if (visible && !reduce) requestAnimationFrame(draw);
    };
    size();
    window.addEventListener('resize', function () { size(); draw(performance.now()); });
    canvas.parentElement.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect(); target = { x: e.clientX - r.left, y: e.clientY - r.top };
    });
    canvas.parentElement.addEventListener('pointerleave', function () { target = null; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var was = visible; visible = entries[0].isIntersecting;
        if (visible && !was) requestAnimationFrame(draw);
      }).observe(canvas);
    }
    draw(performance.now());
  });

  /* Phone swipe rows: a thin progress line under each row tracks the scroll position. */
  document.querySelectorAll('[data-icg-progress]').forEach(function (bar) {
    var root = bar.parentElement;
    var scrollers = root.querySelectorAll('[data-icg-swipe]');
    var thumb = bar.querySelector('span');
    var update = function () {
      var s = null;
      scrollers.forEach(function (el) { if (!el.hidden && el.offsetParent !== null) s = el; });
      if (!s) return;
      var max = s.scrollWidth - s.clientWidth;
      var share = s.scrollWidth ? Math.max(0.12, s.clientWidth / s.scrollWidth) : 1;
      var w = bar.clientWidth * share;
      thumb.style.setProperty('--icg-pw', w + 'px');
      thumb.style.setProperty('--icg-px', (max > 0 ? (s.scrollLeft / max) * (bar.clientWidth - w) : 0) + 'px');
    };
    scrollers.forEach(function (el) { el.addEventListener('scroll', update, { passive: true }); });
    root.querySelectorAll('[role="tab"]').forEach(function (t) { t.addEventListener('click', function () { setTimeout(update, 0); }); });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------------- Phone "glass deck" (under 750px only) ---------------- */
  var phone = window.matchMedia('(max-width: 749px)');

  /* Tab bar Menu opens the same drawer as the header burger. */
  if (burger) document.querySelectorAll('[data-icg-burger-proxy]').forEach(function (proxy) { proxy.addEventListener('click', function () { burger.click(); }); });

  /* Stacking sections: each home section sticks once its bottom reaches the screen bottom, and the next
     one slides over it like a sheet; the covered one sinks and darkens (--icg-cover 0 to 1). */
  var main = document.querySelector('main');
  var deck = main && document.querySelector('.icg-hero') ? Array.prototype.slice.call(main.children).filter(function (el) {
    return el.classList.contains('shopify-section') && el.querySelector('.icg');
  }) : [];
  var deckOn = false;
  var layoutDeck = function () {
    deckOn = phone.matches && deck.length > 1 && !reduce;
    document.documentElement.classList.toggle('icg-deck', deckOn);
    deck.forEach(function (sec) {
      sec.style.top = deckOn ? Math.min(0, window.innerHeight - sec.offsetHeight) + 'px' : '';
      if (!deckOn) sec.style.removeProperty('--icg-cover');
    });
  };
  var paintDeck = function () {
    if (!deckOn) return;
    var vh = window.innerHeight;
    for (var i = 0; i < deck.length - 1; i++) {
      var nextTop = deck[i + 1].getBoundingClientRect().top;
      var p = Math.max(0, Math.min(1, 1 - nextTop / vh));
      deck[i].style.setProperty('--icg-cover', p.toFixed(3));
    }
  };

  /* Coverflow: cards in a swipe row tilt and shrink in 3D the further they sit from the centre. */
  var flows = document.querySelectorAll('[data-icg-swipe]');
  var paintFlow = function (row) {
    if (!phone.matches || reduce) { Array.prototype.forEach.call(row.children, function (c) { c.style.transform = ''; c.style.opacity = ''; }); return; }
    var r = row.getBoundingClientRect(), mid = r.left + r.width / 2;
    Array.prototype.forEach.call(row.children, function (c) {
      var b = c.getBoundingClientRect();
      var d = Math.max(-1, Math.min(1, ((b.left + b.width / 2) - mid) / r.width));
      c.style.transform = 'perspective(900px) rotateY(' + (-d * 32).toFixed(2) + 'deg) scale(' + (1 - Math.abs(d) * 0.14).toFixed(3) + ')';
      c.style.opacity = (1 - Math.abs(d) * 0.45).toFixed(3);
    });
  };
  var ticking = false;
  var frame = function () { ticking = false; paintDeck(); };
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  flows.forEach(function (row) {
    var t = false;
    row.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(function () { t = false; paintFlow(row); }); } }, { passive: true });
  });
  var relayout = function () { layoutDeck(); paintDeck(); flows.forEach(paintFlow); };
  window.addEventListener('resize', relayout);
  if (phone.addEventListener) phone.addEventListener('change', relayout);
  if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { layoutDeck(); paintDeck(); }); deck.forEach(function (s) { ro.observe(s); }); }
  document.querySelectorAll('[role="tab"]').forEach(function (t) { t.addEventListener('click', function () { setTimeout(relayout, 0); }); });
  window.addEventListener('load', relayout);
  relayout();
})();

/* Collection page (icg-collection.liquid): search, joint / angle / in-stock filters, sort, grid or list,
   and paging, all on the products already on the page. Filters live in the URL so a link can open a
   filtered list (?joint=14mm&angle=90&stock=1&sort=price-asc&q=fairchild). */
(function () {
  var root = document.querySelector('[data-icg-coll]');
  if (!root) return;
  var grid = root.querySelector('[data-icg-coll-grid]');
  if (!grid) return;
  var pager = root.querySelector('[data-icg-coll-pages]');
  var empty = root.querySelector('[data-icg-coll-empty]');
  var countEl = root.querySelector('[data-icg-coll-count]');
  var countWord = root.querySelector('[data-icg-coll-word]');
  var q = root.querySelector('[data-icg-coll-q]');
  var sortEl = root.querySelector('[data-icg-coll-sort]');
  var bar = root.querySelector('[data-icg-coll-bar]');
  var chips = [].slice.call(root.querySelectorAll('.icg-coll__chip'));
  var clears = [].slice.call(root.querySelectorAll('[data-icg-coll-clear]'));
  var modes = [].slice.call(root.querySelectorAll('[data-icg-coll-mode]'));
  var per = parseInt(root.getAttribute('data-per-page'), 10) || 24;
  /* An optional wide feature tile (icg-coll-feature) sits after the Nth card; it is not a product, so keep it out of the list. */
  var feature = grid.querySelector('[data-icg-coll-feature]');
  var featAfter = 0;
  if (feature) for (var fn = feature.previousElementSibling; fn; fn = fn.previousElementSibling) featAfter++;
  var items = [].slice.call(grid.children).filter(function (n) { return n !== feature; });

  var params = new URLSearchParams(location.search);
  /* On the search page (icg-search.liquid, TASK-34) ?q= is the store search term: never filter on it, never drop it. */
  var keepQ = root.hasAttribute('data-icg-coll-keepq');
  var state = { joint: [], angle: [], stock: [], kind: [], q: keepQ ? '' : (params.get('q') || ''), sort: params.get('sort') || 'featured' };
  ['joint', 'angle', 'stock', 'kind'].forEach(function (k) { var v = params.get(k); state[k] = v ? v.split(',') : []; });
  var page = parseInt(params.get('p'), 10) || 1;

  /* Shopify splits a collection over 250 products into pages; fetch the rest so the filters see everything. */
  var serverPages = [].slice.call(pager.querySelectorAll('a.icg-coll__page')).map(function (a) { return a.href; });
  function loadRest(done) {
    var links = serverPages;
    if (!links.length || params.get('page')) return done();
    Promise.all(links.map(function (u) { return fetch(u).then(function (r) { return r.text(); }); })).then(function (pages) {
      pages.forEach(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-icg-coll-grid] > .icg-coll__item').forEach(function (n) {
          n.setAttribute('data-i', items.length);
          grid.appendChild(n);
          items.push(n);
        });
      });
      done();
    }).catch(done);
  }

  function writeUrl() {
    var p = new URLSearchParams(location.search);
    ['joint', 'angle', 'stock', 'kind'].forEach(function (k) { if (state[k].length) p.set(k, state[k].join(',')); else p.delete(k); });
    if (!keepQ) { if (state.q) p.set('q', state.q); else p.delete('q'); }
    if (state.sort !== 'featured') p.set('sort', state.sort); else p.delete('sort');
    if (page > 1) p.set('p', page); else p.delete('p');
    var s = p.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : ''));
  }

  function matches(n) {
    var j = (n.getAttribute('data-joint') || '').split(' ');
    var a = (n.getAttribute('data-angle') || '').split(' ');
    if (state.joint.length && !state.joint.some(function (v) { return j.indexOf(v) > -1; })) return false;
    if (state.angle.length && !state.angle.some(function (v) { return a.indexOf(v) > -1; })) return false;
    if (state.stock.length && n.getAttribute('data-stock') !== '1') return false;
    if (state.kind.length && state.kind.indexOf(n.getAttribute('data-kind')) < 0) return false;
    if (state.q) {
      var hay = n.getAttribute('data-find') || '';
      var words = state.q.toLowerCase().split(/\s+/);
      for (var i = 0; i < words.length; i++) if (hay.indexOf(words[i]) < 0) return false;
    }
    return true;
  }

  /* Featured keeps the store's order but puts sold-out pieces after the ones you can buy. */
  function order(list) {
    var num = function (n, k) { return parseFloat(n.getAttribute(k)) || 0; };
    var sorts = {
      featured: function (x, y) { return (num(y, 'data-stock') - num(x, 'data-stock')) || (num(x, 'data-i') - num(y, 'data-i')); },
      'price-asc': function (x, y) { return (num(x, 'data-price') - num(y, 'data-price')) || (num(x, 'data-i') - num(y, 'data-i')); },
      'price-desc': function (x, y) { return (num(y, 'data-price') - num(x, 'data-price')) || (num(x, 'data-i') - num(y, 'data-i')); },
      name: function (x, y) { return (x.getAttribute('data-name') || '').localeCompare(y.getAttribute('data-name') || ''); }
    };
    return list.slice().sort(sorts[state.sort] || sorts.featured);
  }

  function pageButton(label, n, on) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'icg-coll__page' + (on ? ' is-on' : '');
    b.textContent = label;
    if (on) b.setAttribute('aria-current', 'page');
    b.addEventListener('click', function () {
      page = n;
      render();
      var top = root.querySelector('[data-icg-coll-grid]').getBoundingClientRect().top + window.scrollY - bar.offsetHeight - 60;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    });
    return b;
  }

  function render() {
    var shown = order(items.filter(matches));
    var pages = Math.max(1, Math.ceil(shown.length / per));
    if (page > pages) page = pages;
    if (page < 1) page = 1;
    items.forEach(function (n) { n.hidden = true; });
    shown.forEach(function (n, i) {
      grid.appendChild(n);
      n.hidden = !(i >= (page - 1) * per && i < page * per);
    });
    var any = state.joint.length || state.angle.length || state.stock.length || state.kind.length || state.q;
    if (feature) {
      var showF = !any && state.sort === 'featured' && page === 1 && shown.length >= featAfter;
      feature.hidden = !showF;
      if (showF) shown[featAfter - 1].after(feature);
    }
    countEl.textContent = shown.length;
    if (countWord) countWord.textContent = shown.length === 1 ? 'product' : 'products';
    empty.hidden = shown.length > 0;
    grid.hidden = shown.length === 0;

    pager.innerHTML = '';
    if (pages > 1) {
      var list = [];
      for (var i = 1; i <= pages; i++) {
        if (i === 1 || i === pages || Math.abs(i - page) <= 1) list.push(i);
        else if (list[list.length - 1] !== 0) list.push(0);
      }
      list.forEach(function (n) {
        if (!n) { var s = document.createElement('span'); s.className = 'icg-coll__page is-gap'; s.textContent = '…'; pager.appendChild(s); }
        else pager.appendChild(pageButton(String(n), n, n === page));
      });
      if (page < pages) { var nx = pageButton('Next', page + 1, false); nx.classList.add('is-next'); pager.appendChild(nx); }
    }

    chips.forEach(function (c) {
      var v = c.getAttribute('data-v'), list = state[c.getAttribute('data-k')];
      var on = v === '' ? !list.length : list.indexOf(v) > -1;
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    clears.forEach(function (c) { if (c.closest('[data-icg-coll-filters]')) c.hidden = !any; });
    writeUrl();
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var k = c.getAttribute('data-k'), v = c.getAttribute('data-v'), at = state[k].indexOf(v);
      if (k === 'kind') state.kind = (v === '' || at > -1) ? [] : [v];   /* type chips pick one at a time; All clears */
      else if (at > -1) state[k].splice(at, 1); else state[k].push(v);
      page = 1;
      render();
    });
  });
  clears.forEach(function (c) {
    c.addEventListener('click', function () {
      state.joint = []; state.angle = []; state.stock = []; state.kind = []; state.q = ''; if (q) q.value = ''; page = 1;
      render();
    });
  });
  var qt;
  if (q) {
    q.value = state.q;
    q.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { state.q = q.value.trim(); page = 1; render(); }, 120); });
    q.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  }
  sortEl.value = state.sort;
  sortEl.addEventListener('change', function () { state.sort = sortEl.value; page = 1; render(); });

  var setMode = function (m) {
    root.classList.toggle('is-list', m === 'list');
    modes.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-icg-coll-mode') === m ? 'true' : 'false'); });
    try { localStorage.setItem('icg-coll-mode', m); } catch (e) {}
  };
  modes.forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-icg-coll-mode')); }); });
  try { if (localStorage.getItem('icg-coll-mode') === 'list') setMode('list'); } catch (e) {}

  root.classList.add('is-ready');
  render();
  loadRest(render);
})();

/* Product page (icg-product.liquid): photo track, options to variant, other sizes of the same piece,
   quantity, add to cart in place, Read more, and the related row (icg-related.liquid). */
(function () {
  var root = document.querySelector('[data-icg-pdp]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var data = {};
  try { data = JSON.parse($('[data-icg-pdp-json]').textContent); } catch (e) {}
  var money = function (cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* Back: return to where the shopper came from when that was this store, else the collection link. */
  var back = $('[data-icg-back]');
  if (back && document.referrer && document.referrer.indexOf(location.host) > -1 && history.length > 1) {
    back.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
  }

  /* Photos: a scroll-snap track; dots, arrows and arrow keys move it. */
  var track = $('[data-icg-pdp-track]');
  var slides = $$('.icg-pdp__slide');
  var dots = $$('[data-icg-pdp-dot]');
  var current = 0;
  var go = function (i, smooth) {
    if (!slides.length) return;
    current = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[current].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  };
  var onTrack = function () {
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    current = i;
    dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
  };
  if (track) {
    var tt;
    track.addEventListener('scroll', function () { clearTimeout(tt); tt = setTimeout(onTrack, 60); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-icg-pdp-dot'), 10)); }); });
    $$('[data-icg-pdp-step]').forEach(function (b) { b.addEventListener('click', function () { go(current + parseInt(b.getAttribute('data-icg-pdp-step'), 10)); }); });
    window.addEventListener('resize', function () { go(current, false); });
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }
  var showMedia = function (mediaId) {
    if (!mediaId) return;
    for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
  };

  /* Options to variant. */
  var idInput = $('[data-icg-pdp-id]');
  var addBtn = $('[data-icg-pdp-add]');
  var addText = $('[data-icg-pdp-add-text]');
  var addPrice = $('[data-icg-pdp-add-price]');
  var setText = function (sel, t) { $$(sel).forEach(function (n) { n.textContent = t; }); };
  var applyVariant = function (vt) {
    var avail = vt && vt.available;
    if (vt) {
      idInput.value = vt.id;
      setText('[data-icg-pdp-price]', money(vt.price));
      var cmp = $('[data-icg-pdp-compare]');
      if (cmp) { cmp.hidden = !(vt.compare_at_price > vt.price); cmp.textContent = vt.compare_at_price ? money(vt.compare_at_price) : ''; }
      var sv = $('[data-icg-pdp-save]');
      if (sv) { sv.hidden = !(vt.compare_at_price > vt.price); sv.textContent = sv.hidden ? '' : 'Save ' + money(vt.compare_at_price - vt.price); }
      setText('[data-icg-pdp-sku]', vt.sku || root.getAttribute('data-series'));
      setText('[data-icg-pdp-sku2]', vt.sku || '');
      setText('[data-icg-pdp-sku3]', vt.sku || '');
      if (vt.featured_media) showMedia(vt.featured_media.id);
      try { var u = new URL(location.href); u.searchParams.set('variant', vt.id); history.replaceState(history.state, '', u.pathname + u.search); } catch (e) {}
    }
    setText('[data-icg-pdp-stock-text]', avail ? 'In stock' : vt ? 'Sold out' : 'Not available');
    setText('[data-icg-pdp-avail]', avail ? 'In stock' : 'Sold out');
    var ind = $('[data-icg-pdp-stock] .icg-pdp__ind'); if (ind) ind.classList.toggle('is-out', !avail);
    addBtn.disabled = !avail;
    var add2 = $('[data-icg-pdp-add2]'); if (add2) { add2.disabled = !avail; add2.textContent = avail ? 'Add to cart' : 'Sold out'; }
    addText.textContent = avail ? 'Add to cart' : vt ? 'Sold out' : 'Not available';
    addPrice.textContent = avail ? money(vt.price) : '';
  };
  var opts = $$('[data-icg-pdp-opt]');
  opts.forEach(function (r) {
    r.addEventListener('change', function () {
      var chosen = [];
      opts.forEach(function (o) { if (o.checked) chosen[parseInt(o.getAttribute('data-icg-pdp-opt'), 10)] = o.value; });
      chosen.forEach(function (val, i) { setText('[data-icg-pdp-picked="' + i + '"]', val); });
      var vt = (data.variants || []).filter(function (x) { return x.options.every(function (ov, i) { return chosen[i] === undefined || ov === chosen[i]; }); })[0];
      applyVariant(vt || null);
    });
  });
  /* Mark option values with no buyable variant. */
  if (data.variants && data.options && data.options.length === 1) {
    opts.forEach(function (o) {
      var vt = data.variants.filter(function (x) { return x.options[0] === o.value; })[0];
      if (vt && !vt.available) o.parentNode.classList.add('is-out');
    });
  }

  /* Quantity. */
  var qty = $('[data-icg-pdp-qty]');
  $$('[data-icg-pdp-qstep]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-icg-pdp-qstep'), 10);
      qty.value = Math.max(1, Math.min(99, n));
    });
  });

  /* Add to cart in place; a normal form post still works without JavaScript. */
  var form = $('[data-icg-pdp-form]');
  var msg = $('[data-icg-pdp-msg]');
  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
  form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    addText.textContent = 'Adding';
    fetch(cartUrl + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.icg-hdr__count').forEach(function (c) { c.textContent = cart.item_count; });
        if (!document.querySelector('.icg-hdr__count')) {
          var icon = document.querySelector('.icg-hdr__icon[href$="/cart"]');
          if (icon) { var s = document.createElement('span'); s.className = 'icg-hdr__count'; s.textContent = cart.item_count; icon.appendChild(s); }
        }
        document.querySelectorAll('.icg-tabbar a[href$="/cart"] .icg-mono').forEach(function (c) { c.textContent = 'Cart ' + cart.item_count; });
        msg.hidden = false;
        msg.innerHTML = 'Added. <a href="' + cartUrl + '">View cart (' + cart.item_count + ')</a>';
        addText.textContent = 'Added';
        setTimeout(function () { addText.textContent = 'Add to cart'; addBtn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        msg.hidden = false;
        msg.textContent = (err && (err.description || err.message)) || 'Could not add that. Please try again.';
        addText.textContent = 'Add to cart';
        addBtn.disabled = false;
      });
  });

  /* TASK-36 Details tabs: one panel at a time once this runs; every panel shows without it. */
  var tabBar = $('[data-icg-pdp-tabs]');
  if (tabBar) {
    var tabs = [].slice.call(tabBar.querySelectorAll('[role=tab]'));
    var openTab = function (t) {
      tabs.forEach(function (b) {
        var on = b.getAttribute('data-t') === t;
        b.setAttribute('aria-selected', on ? 'true' : 'false'); b.classList.toggle('is-on', on); b.tabIndex = on ? 0 : -1;
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    };
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { openTab(b.getAttribute('data-t')); });
      b.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
        var n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); openTab(n.getAttribute('data-t'));
      });
    });
    tabBar.hidden = false;
    if (tabs[0]) openTab(tabs[0].getAttribute('data-t'));
    /* Jump to links (and the Specs "In Resources" link) open their tab, then scroll to the Details block. */
    document.querySelectorAll('[data-icg-pdp-go]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = a.getAttribute('data-icg-pdp-go');
        if (!tabs.some(function (b) { return b.getAttribute('data-t') === t; })) return;
        e.preventDefault(); openTab(t);
        tabBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* TASK-36 Reviews: Vitals appends its widget at the end of the page; move it into the Reviews block and show the block. */
  var revSlot = $('[data-icg-pdp-reviews]');
  if (revSlot) {
    var moveRev = function () {
      var w = document.getElementById('vitals-end-section');
      if (w && w.querySelector('.vtl-pr-main-widget')) { revSlot.appendChild(w); revSlot.parentNode.hidden = false; return true; }
      return false;
    };
    if (!moveRev() && window.MutationObserver) {
      var mo = new MutationObserver(function () { if (moveRev()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
  }

  /* TASK-36 sticky Add to cart (phones): shown once the buy row has scrolled up out of view; it submits the main form. */
  var sticky = $('[data-icg-pdp-sticky]'), buyRow = $('.icg-pdp__buy'), add2b = $('[data-icg-pdp-add2]');
  if (sticky && buyRow) {
    var was = null;
    var checkSticky = function () {
      var on = buyRow.getBoundingClientRect().bottom < 0;
      if (on === was) return; was = on;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (add2b) add2b.tabIndex = on ? 0 : -1;
    };
    window.addEventListener('scroll', checkSticky, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
    if (add2b) add2b.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
    });
  }

  /* Read more on long descriptions. */
  var rte = $('[data-icg-pdp-rte]'), more = $('[data-icg-pdp-more]');
  if (rte && more) {
    var check = function () { if (rte.scrollHeight > rte.clientHeight + 4) more.hidden = false; };
    check(); window.addEventListener('load', check);
    more.addEventListener('click', function () {
      var open = rte.classList.toggle('is-open');
      more.textContent = open ? 'Read less' : 'Read more';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Other sizes of the same piece: separate products here, found with predictive search on the series word. */
  var series = root.getAttribute('data-series');
  var row = $('[data-icg-pdp-series]'), list = $('[data-icg-pdp-series-list]');
  var norm = function (t) {
    t = (t || '').split('|')[0].toLowerCase().replace(/^\s*ic\s+(glass|quartz)\s*[-–:]?\s*/, '');
    var w = t.split(/\s+/), out = [];
    for (var i = 0; i < w.length; i++) { if (/\d/.test(w[i])) break; out.push(w[i]); }
    return out.join(' ').replace(/[^a-z ]/g, '').trim();
  };
  var label = function (t) {
    var s = (t || '').toLowerCase();
    var j = (s.match(/\b(10|14|18)\s?m(?:m)?\b|\b(10|14|18)m(?=45|90)/) || [])[0];
    var a = (s.match(/(45|90)\s?(?:d\b|°|�|-?\s?degree)|m(45|90)d?\b/) || []);
    var jj = j ? j.replace(/\D/g, '') + 'MM' : '';
    var aa = a[1] || a[2] ? (a[1] || a[2]) + '°' : '';
    return (jj + ' ' + aa).trim();
  };
  if (series && row && window.fetch) {
    var me = norm(data.title);
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(series) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var found = (((j || {}).resources || {}).results || {}).products || [];
      var sibs = found.filter(function (p) { return norm(p.title) === me && me.length > 2; });
      if (!sibs.some(function (p) { return p.handle === data.handle; })) sibs.unshift({ title: data.title, handle: data.handle, url: location.pathname, image: data.featured_image, price: data.price / 100 });
      var seen = {}, items = [];
      sibs.forEach(function (p) {
        var l = label(p.title) || p.title.split('|')[0].trim();
        if (seen[l]) return; seen[l] = 1; items.push({ p: p, l: l });
      });
      if (items.length < 2) return;
      items.sort(function (x, y) { return x.l.localeCompare(y.l, undefined, { numeric: true }); });
      items.forEach(function (it) {
        var on = it.p.handle === data.handle;
        var a = document.createElement(on ? 'span' : 'a');
        a.className = 'icg-pdp__sib' + (on ? ' is-on' : '');
        if (!on) a.href = (it.p.url || '/products/' + it.p.handle).split('?')[0];
        else a.setAttribute('aria-current', 'page');
        var img = it.p.image || (it.p.featured_image && it.p.featured_image.url) || '';
        a.innerHTML = '<span class="icg-mono"></span>' + (img ? '<img alt="" loading="lazy" src="' + String(img).replace(/"/g, '') + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=200">' : '');
        a.firstChild.textContent = it.l;
        list.appendChild(a);
      });
      row.hidden = false;
    }).catch(function () {});
  }
})();

(function () {
  /* Every recommendations row (TASK-36: related + complementary). */
  if (!window.fetch) return;
  document.querySelectorAll('[data-icg-rel]').forEach(function (rel) {
    fetch(rel.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-icg-rel]');
      if (fresh && fresh.innerHTML.trim()) rel.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();

/* TASK-36 breadcrumb (snippets/icg-crumb.liquid): the collection the shopper came from, when the product is in it. */
(function () {
  var data = document.querySelector('[data-icg-crumb-json]');
  if (!data || !document.referrer) return;
  try {
    var ref = new URL(document.referrer);
    var m = ref.host === location.host && ref.pathname.match(/\/collections\/([^\/?#]+)/);
    var hit = m && JSON.parse(data.textContent).filter(function (c) { return c.h === decodeURIComponent(m[1]); })[0];
    if (!hit) return;
    document.querySelectorAll('[data-icg-crumb]').forEach(function (nav) {
      var main = nav.querySelector('[data-icg-crumb-main]'); if (!main) return;
      main.textContent = hit.t; main.href = hit.u;
      var par = nav.querySelector('[data-icg-crumb-parent]');
      if (hit.pt) {
        if (!par) {
          par = document.createElement('a'); par.setAttribute('data-icg-crumb-parent', '');
          var sep = document.createElement('span'); sep.setAttribute('aria-hidden', 'true'); sep.textContent = '›';
          nav.insertBefore(par, main.previousElementSibling); nav.insertBefore(sep, main.previousElementSibling);
        }
        par.textContent = hit.pt; par.href = hit.pu;
      } else if (par) { if (par.nextElementSibling) par.nextElementSibling.remove(); par.remove(); }
    });
  } catch (e) {}
})();

/* Blog list (icg-blog.liquid): "Load more" appends the next page in place; the link still works without JavaScript. */
(function () {
  var more = document.querySelector('[data-icg-blog-more]');
  var grid = document.querySelector('[data-icg-blog-grid]');
  if (!more || !grid || !window.fetch) return;
  more.addEventListener('click', function (e) {
    e.preventDefault();
    var url = more.getAttribute('href');
    if (!url || more.getAttribute('aria-busy') === 'true') return;
    more.setAttribute('aria-busy', 'true');
    more.textContent = 'Loading';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-icg-blog-grid] > li').forEach(function (li) { grid.appendChild(li); });
      var next = doc.querySelector('[data-icg-blog-more]');
      if (next) { more.setAttribute('href', next.getAttribute('href')); more.textContent = 'Load more'; more.removeAttribute('aria-busy'); }
      else { more.parentNode.remove(); }
    }).catch(function () { location.href = url; });
  });
})();

/* Cart (icg-cart.liquid): quantity steppers and Remove use /cart/change.js, then the section is re-rendered in
   place and the header counts are updated. Without JavaScript the form and the remove links still work. */
(function () {
  var root = function () { return document.querySelector('[data-icg-cart]'); };
  if (!root() || !window.fetch) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var setCounts = function (n) {
    document.querySelectorAll('.icg-hdr__count').forEach(function (c) { c.textContent = n; if (!n) c.remove(); });
    document.querySelectorAll('.icg-tabbar a[href$="/cart"] .icg-mono').forEach(function (c) { c.textContent = n ? 'Cart ' + n : 'Cart'; });
  };
  var change = function (line, qty) {
    if (busy) return;
    busy = true;
    var r = root(); r.classList.add('is-busy');
    var id = r.getAttribute('data-section');
    fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: [id], sections_url: location.pathname }) })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function (cart) {
        var html = cart.sections && cart.sections[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-icg-cart]');
          if (fresh) root().innerHTML = fresh.innerHTML;
        } else { location.reload(); return; }
        setCounts(cart.item_count);
      })
      .catch(function (err) {
        var m = root().querySelector('[data-icg-cart-msg]');
        if (m) { m.hidden = false; m.textContent = (err && (err.description || err.message)) || 'Could not update the cart. Please try again.'; }
      })
      .then(function () { busy = false; var x = root(); if (x) x.classList.remove('is-busy'); });
  };
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-icg-cart-step]');
    var rem = e.target.closest('[data-icg-cart-remove]');
    if (!step && !rem) return;
    var lineEl = e.target.closest('[data-line]');
    if (!lineEl || !root().contains(lineEl)) return;
    e.preventDefault();
    var line = parseInt(lineEl.getAttribute('data-line'), 10);
    if (rem) return change(line, 0);
    var input = lineEl.querySelector('[data-icg-cart-qty]');
    var q = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-icg-cart-step'), 10)));
    input.value = q;
    change(line, q);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-icg-cart-qty]');
    if (!input || !root().contains(input)) return;
    var lineEl = input.closest('[data-line]');
    change(parseInt(lineEl.getAttribute('data-line'), 10), Math.max(0, Math.min(99, parseInt(input.value, 10) || 0)));
  });
})();

/* Search (icg-search.liquid): Products / Guides & pages tabs. Opens on guides when no product matched. */
(function () {
  var root = document.querySelector('[data-icg-search]');
  if (!root) return;
  var tabs = [].slice.call(root.querySelectorAll('[data-icg-search-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-icg-search-panel]'));
  var show = function (name) {
    tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-icg-search-tab') === name ? 'true' : 'false'); });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-icg-search-panel') !== name; });
  };
  tabs.forEach(function (t) { t.addEventListener('click', function () { if (!t.disabled) show(t.getAttribute('data-icg-search-tab')); }); });
  var prod = root.querySelector('[data-icg-search-panel="products"] .icg-coll__item');
  var other = root.querySelector('[data-icg-search-panel="other"] li');
  if (!prod && other) show('other');
})();

/* About page (icg-page.liquid, about mode): the sticky photo on the left shows the chapter that is in view. */
(function () {
  var pics = document.querySelectorAll('[data-icg-abt-pic]');
  var chs = document.querySelectorAll('[data-icg-abt-ch]');
  if (!pics.length || !chs.length) return;
  var show = function (n) { pics.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-icg-abt-pic') === String(n)); }); };
  show(chs[0].getAttribute('data-icg-abt-ch'));
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) show(e.target.getAttribute('data-icg-abt-ch')); });
  }, { rootMargin: '-45% 0px -45% 0px' });
  chs.forEach(function (c) { io.observe(c); });
})();
